<div class="dialog-container">
  <div class="dialog-content">
    <div class="dialog-header">
      <h2>Edit User Information</h2>
      <button class="close-button" (click)="onCancel()">×</button>
    </div>

    <form [formGroup]="userForm" class="user-form">
      <div class="form-field">
        <label for="firstName">First Name</label>
        <input type="text" id="firstName" formControlName="firstName" class="form-input">
        <mat-error *ngIf="userForm.get('firstName')?.hasError('required')">
          First Name is required
        </mat-error>
        <mat-error *ngIf="userForm.get('firstName')?.hasError('minlength')">
          First Name must be at least 3 characters long
        </mat-error>
        <mat-error *ngIf="userForm.get('firstName')?.hasError('maxlength')">
          First Name cannot exceed 15 characters
        </mat-error>
      </div>

      <div class="form-field">
        <label for="lastName">Last Name</label>
        <input type="text" id="lastName" formControlName="lastName" class="form-input">
        <mat-error *ngIf="userForm.get('lastName')?.hasError('required')">
          Last Name is required
        </mat-error>
        <mat-error *ngIf="userForm.get('lastName')?.hasError('minlength')">
          Last Name must be at least 3 characters long
        </mat-error>
        <mat-error *ngIf="userForm.get('lastName')?.hasError('maxlength')">
          Last Name cannot exceed 15 characters
        </mat-error>
      </div>

      <div class="form-field">
        <label for="phone">Phone</label>
        <input type="tel" id="phone" formControlName="phone" class="form-input">
        <mat-error *ngIf="userForm.get('phone')?.hasError('required')">
          Phone number is required
        </mat-error>
        <mat-error *ngIf="userForm.get('phone')?.hasError('minlength')">
          Phone number must be exactly 10 digits
        </mat-error>
        <mat-error *ngIf="userForm.get('phone')?.hasError('maxlength')">
          Phone number must be exactly 10 digits
        </mat-error>
        <mat-error *ngIf="userForm.get('phone')?.hasError('pattern')">
          Phone number must contain only numbers
        </mat-error>
      </div>

      <div class="dialog-actions">
        <button class="cancel-button" (click)="onCancel()">Cancel</button>
        <button class="save-button" (click)="onSave()" [disabled]="!userForm.valid">Save</button>
      </div>
    </form>
  </div>
</div>
